import React, { useState, useEffect } from "react";
import { Flex, Text } from "components";
import * as S from "./AdminEventDetails.styled";
import { ORDERS } from "api";
import AdminTable from "../AdminTable";

export default ({ eventDetails: { id } }) => {
  const [orderInfo, setOrderInfo] = useState(null);

  const getOrders = async (pageId) => {
    try {
      const {
        data: { data },
      } = await ORDERS.getAllPageOrders(pageId);
      setOrderInfo(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    id && getOrders(id);
  }, [id]);

  return (
    <S.ListContainer margin="24px 0 0" maxHeight="450px">
      <Flex justify="space-between" align="center" margin="0 0 24px 0">
        <Text size="24px" weight="bold">
          Orders
        </Text>
      </Flex>

      {orderInfo?.length > 0 ? (
        <AdminTable type="event_orders" data={orderInfo} />
      ) : (
        <Flex>
          <Text>No Event Orders</Text>
        </Flex>
      )}
    </S.ListContainer>
  );
};
